import { createComponent } from "@front/utils/alpine";

export default createComponent(() => ({
    $store: {} as { [ key: string ]: any },
    previousAnswerCount: 0, // To track how many answers we had before

    async submit() {
        // Get the selected answers
        const radios = document.querySelectorAll('.form-questions input:checked');
        const currentAnswerCount = radios.length;

        // Get the total number of questions
        let totalQuestions = document.querySelectorAll('.form-questions input[type="radio"]').length;
        totalQuestions = totalQuestions/2;
        //console.log('totalQuestions', totalQuestions);
        // Initialize needAnswer if not already set (first load before productSelector.getQuestion runs)
        if (this.$store.needAnswer === undefined) {
            this.$store.needAnswer = totalQuestions > 0;
        }
        // Check if we are answering the second question (the counter increased to 2)
        let isAnsweringSecondQuestion = false;
        
        if (this.$store.needAnswer === true) {
            let eventype;
            if(this.product.id === 7) { eventype = 'finition'; }
            if(this.product.id === 4 || this.product.id === 14) { eventype = 'seats'; }

            const choicesGrp = document.querySelectorAll(`.event-`+ eventype +` input`);
            choicesGrp.forEach((element) => {
                element.setAttribute('disabled', 'disabled');
            });
        }

        if(currentAnswerCount === totalQuestions) {
            isAnsweringSecondQuestion = true;
            let eventype;
            if(this.product.id === 7) { eventype = 'finition'; }
            if(this.product.id === 4 || this.product.id === 14) { eventype = 'seats'; }
            const choicesGrp = document.querySelectorAll(`.event-`+ eventype +` input`);
            choicesGrp.forEach((element) => {
                element.removeAttribute('disabled');
            });
        }
        //console.log('isAnserw', isAnsweringSecondQuestion);

        const answersDim = Array.from(radios)
            .map(el => el.getAttribute('data-value'))
            .filter(e => !!e);

        const solutionDim = answersDim.length > 0 ? answersDim.join('|') : 'NO';

        // Map the selected answers to an array of objects
        const answers = Array.from(radios)
            .map((el) => {
                const input = el as HTMLInputElement;

                // Extract the question identifier consistently
                // Use name to extract the question ID (always Q followed by a number)
                const questionId = input.name; // This will be something like "Q1", "Q2", etc.

                // Extract the question text from the nearest element
                const questionElement = input.closest('.mt-6')?.querySelector('p');
                const questionText = questionElement?.textContent?.trim() || questionId;

                // Determine the answer (Yes or No) based on the input value
                const answer = input.value === "1" ? "Oui" : "Non";

                return {
                    id: questionId,
                    question: questionText,
                    answer: answer,
                    value: input.value // Also save the original value (0 or 1)
                };
            })
            .filter(Boolean);

        // Create a string with the IDs of questions and their answers for the server
        // Format: Q1|Q2|Q3 (only includes questions with answer "Yes", value 1)
        let questionAnswers = answers
            .filter(a => a?.value === "1") // Only include "Yes" answers
            .map(a => a?.id)
            .join('|');

        const vehicleId = document.querySelector('#question_vehicle_id')?.getAttribute('value');
        const product = document.querySelector('#product_page_product_id')?.getAttribute('value');

        // Fetch the response from the server
        const response = await fetch(
            `/modules/tailor/webservice/responses-ajax.php?id_product=${product}&id_vehicle=${vehicleId}&solution=${questionAnswers}`
        );
        //console.log('reponse', response);

        const responseDim = await fetch(
            `/modules/tailor/webservice/responses-ajax.php?id_product=${product}&id_vehicle=${vehicleId}&solution=${solutionDim}`
        );
        //console.log('reponseDim', responseDim);

        const content = await response.json(); //console.log('template_code', content.template_code);
        const contentDim = await responseDim.json(); //console.log('template_codeDim', contentDim.template_code);
        // Process the server response

        //console.log('store.needAnswer', this.$store.needAnswer);

        if(this.$store.needAnswer === true){}

        if (contentDim.template_code === '') {
            // Show error if it is the second question or if there is only one question            
            this.$store.incorrectSolution = true;
            return;
        }

        this.$store.incorrectSolution = false;    

        // Get the form
        const form = document.querySelector('#add-to-cart-or-refresh') as HTMLFormElement;
        if (!form) return;

        // Create the complete data object to send
        // Includes all questions and answers, not just those with value "Oui"
        let dataTemplateCode;
        if(contentDim.template_code){
            let productQuestion = document.querySelector('.js-tpl-code-response') as HTMLInputElement;
            productQuestion.value = contentDim.template_code;
            dataTemplateCode = contentDim.template_code;
        }else{
            dataTemplateCode = content.template_code;
        }
        /* Force templateCode */
        let productMessage = document.querySelectorAll('.js-product-message');
        this.customization.templateCode = dataTemplateCode;
        productMessage[1].textContent = this.customization.templateCode;

        if(!questionAnswers){
            questionAnswers = solutionDim;
        }
        
        const templateData = {
            template_code: dataTemplateCode,
            answers: questionAnswers,
            questions: answers.map(a => ({
                question: a?.question || '',
                answer: a?.answer || '',
                questionId: a?.id || '',
                value: a?.value || ''
            }))
        };

        // 1. Ensure that the field customization[0] (vehicle ID) exists and has the correct value
        let vehicleField = form.querySelector('input[name="customization[0]"]') as HTMLInputElement;
        if (!vehicleField) {
            vehicleField = document.createElement('input');
            vehicleField.type = 'hidden';
            vehicleField.name = 'customization[0]';
            form.appendChild(vehicleField);
        }
        vehicleField.value = vehicleId || '';

        // 2. Ensure that the field customization[1] (template code) exists and has the correct value
        let templateCodeField = form.querySelector('input[name="customization[1]"]') as HTMLInputElement;
        if (!templateCodeField) {
            templateCodeField = document.createElement('input');
            templateCodeField.type = 'hidden';
            templateCodeField.name = 'customization[1]';
            form.appendChild(templateCodeField);
        }
        templateCodeField.value = dataTemplateCode || '';

        // 3. CRITICAL: Ensure that the field customization[template_question] exists with all question data
        let templateQuestionField = form.querySelector('input[name="customization[template_question]"]') as HTMLInputElement;
        if (!templateQuestionField) {
            templateQuestionField = document.createElement('input');
            templateQuestionField.type = 'hidden';
            templateQuestionField.name = 'customization[template_question]';
            form.appendChild(templateQuestionField);
        }
        templateQuestionField.value = JSON.stringify(templateData);

        // Also set the value in the .js-product-template-question field (which might be different)
        const jsTemplateQuestion = form.querySelector('.js-product-template-question') as HTMLInputElement;
        if (jsTemplateQuestion) {
            jsTemplateQuestion.value = JSON.stringify(templateData);
        }

        // Debug - Uncomment if you need to debug
        /*
        console.log('Answers collected:', answers);
        console.log('Question Answers string:', questionAnswers);
        console.log('Template Data:', templateData);
        console.log('Vehicle ID field:', vehicleField);
        console.log('Template code field:', templateCodeField);
        console.log('Template question field:', templateQuestionField);
        console.log('JS Template question field:', jsTemplateQuestion);
        */

        // Send the form
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

        // Use contentDim if it has data, otherwise fallback to content
        const contentToUpdate = contentDim.template_code ? contentDim : content;

        this.$store.vehicle = {
            ...this.$store.vehicle,
            ...contentToUpdate,
        };
    }
}));
